import { z } from "zod";
import { TObjectBase } from "../base";
import { TTranslationData } from "../common/translation";

export const TRawFeatureFlags = z
  .object({
    enabledCompanies: z.array(z.string()).optional(),
    defaultEnabled: z.boolean(),
    toggleable: z.boolean(),
    status: z.enum(["public", "beta", "internal", "archived"]),
    title: TTranslationData.optional(),
    description: TTranslationData.optional(),
  })
  .extend(TObjectBase.shape);

export type IRawFeatureFlags = z.infer<typeof TRawFeatureFlags>;

export const TApiFeatureFlag = z.object({
  id: z.string(),
  isEnabled: z.boolean(),
  toggleable: z.boolean(),
  title: TTranslationData.optional(),
  description: TTranslationData.optional(),
});
export type IApiFeatureFlag = z.infer<typeof TApiFeatureFlag>;

export const TApiFeatureFlagsResponse = z.object({
  featureFlags: z.array(TApiFeatureFlag),
});
export type IApiFeatureFlagsResponse = z.infer<typeof TApiFeatureFlagsResponse>;
